
<app-title-section></app-title-section>
<div class="card cheque-traites-container" style="margin-left: 15px; margin-right: 15px">
<app-filtre-date (dateFilterChange)="onDateFilterChange($event)"></app-filtre-date>
    <!-- Tabs -->

    <div class="d-flex align-items-center flex-wrap justify-content-between" style="margin-top: 24px; margin-left: 44px; margin-right: 24px; gap: 12px;">
        <div class="d-flex align-items-center flex-wrap" style="gap: 12px;">
            <div class="input-group form-password-toggle d-flex" style="width: 300px;">
                <input
                        type="text"
                        class="form-control"
                        placeholder="Recherche par mot clé"
                        aria-label="Search..."
                        aria-describedby="basic-addon-search1"
                        [(ngModel)]="searchTerm" (ngModelChange)="onSearch()"
                />
                <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon-search1" style="color: black;"><i
                            data-feather="search" [size]="20"></i></span>
                </div>
            </div>
            <button type="button" class="btn btn-outline-primary btn-icon" (click)="toggleFilter()">
                <span data-feather="filter"></span>
            </button>
            <!-- Active Filters Chips -->
            <div class="d-flex align-items-center flex-wrap" style="gap: 8px;" *ngIf="activeFilters.length > 0">
                <div *ngFor="let filter of activeFilters; trackBy: trackByFilterKey" class="filter-chip">
                    <span class="filter-chip-label">{{ filter.label }}:</span>
                    <span class="filter-chip-value">{{ filter.value }}</span>
                    <button type="button" class="filter-chip-close" (click)="removeFilter(filter.key); $event.stopPropagation(); $event.preventDefault()" aria-label="Supprimer le filtre">
                        <i data-feather="x" [size]="14"></i>
                    </button>
                </div>
            </div>
        </div>
        <button type="button" class="btn btn-primary" routerLink="/comptabilite/cheque-traite/ajout">
            <span data-feather="plus" style="color: white;"></span> Ajouter
        </button>
    </div>
        <!-- Filter Panel -->
        <div #filterPanel class="card filter-sidebar length" *ngIf="showFilter" style="width: 350px; box-shadow: 2px 4px 8px rgba(47, 43, 61, 0.14);">
            <div class="card-header d-flex justify-content-between align-items-center" style="margin-top: 2px;">
                <h4 class="card-title mb-0">Filtres</h4>
                <button class="btn btn-sm btn-icon btn-light" (click)="toggleFilter()" aria-label="X">
                    X <i class="bx bx-x"></i>
                </button>
            </div>
            <div class="card-body d-flex flex-column p-1" style="height: 350px; margin: 8px">
                <div class="flex-grow-1 overflow-auto pe-1">
                    <div class="mb-1">
                        <label class="form-label">Type d'opération</label>
                        <div class="d-flex w-100">
                            <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.type_operation">
                                <option value="">Tous</option>
                                <option value="emis">Émis</option>
                                <option value="recu">Reçu</option>
                            </select>
                        </div>
                    </div>

                    <div class="mb-1">
                        <label class="form-label">Type de paiement</label>
                        <div class="d-flex w-100">
                            <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.type_paiement">
                                <option value="">Tous</option>
                                <option value="cheque">Chèque</option>
                                <option value="traite">Traite</option>
                            </select>
                        </div>
                    </div>
                    <div class="mb-1">
                        <label class="form-label">Banque</label>
                        <div class="d-flex w-100">
                            <select class="form-select form-control flex-grow-1" [(ngModel)]="filters.banque_id">
                                <option [value]="null">Toutes</option>
                                <option *ngFor="let banque of banques" [value]="banque.id">
                                    {{ banque.nom || 'Banque sans nom' }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="mb-1">
                        <label class="form-label">Date d’échéance </label>
                        <input type="date" class="form-control mb-1" [(ngModel)]="filters.dateFrom"/>
                        <label class="form-label">Jusqu’a</label>
                        <input placeholder="jusqu’a" type="date" class="form-control" [(ngModel)]="filters.dateTo"/>
                    </div>
                </div>
                <div class="pt-2 d-flex justify-content-end gap-1">
                    <button class="btn btn-outline-secondary " (click)="resetFilters()" style="margin-right: 15px;">Réinitialiser</button>
                    <button class="btn btn-primary " (click)="applyFilters()">Appliquer</button>
                </div>
            </div>
        </div>

    <div style="border-bottom: 1px solid #eee; margin-top: 24px; margin-bottom: 10px"></div>
    <div class="table-responsive">
        <table class="table table-hover">
            <thead class=" custom-thead">
            <tr class="align-middle">
                <th>tYPE</th>
                <th>numéro</th>
                <th>Contact</th>
                <th>Porteur</th>
                <th>Banque</th>
                <th>Date de paiement</th>
                <th>Date d'échéance</th>
                <th>Montant</th>
                <th>état</th>
                <th>ACTIONs</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngIf="isLoading">
                <td colspan="10" class="text-center p-4">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Chargement...</span>
                    </div>
                </td>
            </tr>
            <tr *ngIf="!isLoading && filteredData.length === 0">
                <td colspan="10" class="text-center p-4">
                    <p class="mb-0">Aucun chèque/traite trouvé</p>
                </td>
            </tr>
            <tr *ngFor="let item of paginatedData">
                <td>{{ item.type }}</td>
                <td>{{ item.numero }}</td>
                <td>{{ item.contact }}</td>
                <td>{{ item.porteur }}</td>
                <td>{{ item.banque }}</td>
                <td>{{ item.date_paiement }}</td>
                <td>{{ item.date_echeance }}</td>
                <td><span style="color: #134AD3">{{ item.montant }}</span></td>
                <td>
                    <span [ngClass]="{
                        'badge': true,
                        'badge-paye': item.etat === 'Payé' || item.statut_raw === 'payé' || item.statut_raw === 'paye',
                        'badge-nonPaye': item.etat === 'Non payé' || item.statut_raw === 'non_payé' || item.statut_raw === 'non_paye',
                        'badge-enCours': item.etat === 'En cours' || item.statut_raw === 'en_cours'
                    }">
                        {{ item.etat }}
                    </span>
                </td>
                <td>
                    <div class="d-flex align-items-center action-icon">
                          <span class="icon-circle2" style="margin-right: 20px; cursor: pointer;" (click)="toggleStatut(item)" title="Modifier le statut">
                                <i data-feather="dollar-sign" [size]="16" class="text-warning"></i></span>
                        <button class="unstyled-btn" *ngIf="item.depuis !== 'paiement'" (click)="openArchiveModal(modalVC, item.id)" >

                            <span data-feather="trash-2" [size]="22" class="cursor-pointer text-danger"></span>

                        </button>

                    </div>
                    <ng-template #modalVC let-modal>
                        <div class="modal-header p-0" style="background-color: transparent;">
                            <button type="button" class=" close" style="margin-right: 5px"
                                    (click)="modal.dismiss('Cross click')" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="" style="margin: 62px ; margin-top: 51px">
                            <div class="flex-grow-1  ">
                                <h2 class="modal-title text-center"
                                    style="font-size: 24px; font-weight: 500; margin-left: 60px;margin-right: 60px; color: #2F2B3DE5">
                                    Voulez-vous supprimer ce {{ getSelectedItemType() }}?
                                </h2>
                            </div>
                            <div class="pt-2 d-flex justify-content-center gap-1">
                                <button type="button" class="btn btn-primary" (click)="confirmDelete()" style="margin-right: 16px;">Confirmer</button>
                                <button type="button" class="btn btn-grey" (click)="modal.close('Accept click')" >Annuler</button>
                            </div>

                        </div>
                    </ng-template>
                    <ng-template #modal2 let-modal>
                        <div class="modal-header p-0" style="background-color: transparent;">
                            <button type="button" class=" close" style="margin-right: 5px"
                                    (click)="modal.dismiss('Cross click')" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="" style="margin: 62px ; margin-top: 51px">
                            <div class="flex-grow-1 mb-1 ">
                                <h2 class="modal-title text-center"
                                    style="font-size: 24px; font-weight: 500; margin-left: 60px;margin-right: 60px; color: #2F2B3DE5">
                                    Déposez votre chèque
                                </h2>
                            </div>
                            <div class="">
                                <p style="font-size: 16px; color: #2F2B3DB2; text-align: center">Vous devez déposer votre chèque à la section de dépôt
                                    de la banque pour valider le financement de votre solde de compte bancaire.</p>
                                <p style="font-size: 16px; color: #134AD3"> <strong>Comptabilité > Gestion de la trésorerie > Remise en banque </strong> </p>

                            </div>
                            <div class="pt-2 d-flex justify-content-center gap-1">
                                <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')" style="margin-right: 16px;">OK</button>

                            </div>

                        </div>
                    </ng-template>

                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="row mt-3">
        <div class="col-md-6 col-12">
            <div class="d-flex justify-content-between align-items-center m-1">
                <label class="d-flex align-items-center" style="font-size: 15px;">
                    Afficher
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                            (ngModelChange)="onLimitChange()">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </label>
            </div>
        </div>
        <div class="col-md-6 text-end">
            <div class="d-flex flex-wrap justify-content-end gap-2">
                <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(1)">
                    «
                </div>
                <div class="page-box" [class.disabled]="currentPage === 1"
                     (click)="currentPage > 1 && changePage(currentPage - 1)">‹
                </div>
                <div *ngFor="let page of pages" class="page-box" [class.active]="page === currentPage"
                     (click)="changePage(page)">{{ page }}
                </div>
                <div class="page-box" [class.disabled]="currentPage === totalPages"
                     (click)="currentPage < totalPages && changePage(currentPage + 1)">›
                </div>
                <div class="page-box" [class.disabled]="currentPage === totalPages"
                     (click)="currentPage < totalPages && changePage(totalPages)">»
                </div>
            </div>
        </div>
    </div>
</div>

<app-save #save></app-save>
